"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const routes_1 = require("../../backend/configs/routes");
const fluxible_router_1 = require("fluxible-router");
class default_1 extends fluxible_router_1.RouteStore.withStaticRoutes(routes_1.default) {
    constructor(dispatcher) {
        super(dispatcher);
        this.dispatcher = dispatcher;
    }
    dehydrate() {
        const _a = super.dehydrate(), _b = _a.currentNavigate, { route } = _b, currentNavigate = __rest(_b, ["route"]), dehydrated = __rest(_a, ["currentNavigate"]);
        return Object.assign(Object.assign({}, dehydrated), { currentNavigate });
    }
}
exports.default = default_1;
default_1.storeName = 'RouteStore';
